import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

import { cn } from "./lib/utils";

const inputVariants = cva(
	"file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
	{
		variants: {
			variant: {
				default: "",
				error:
					"border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
				success:
					"border-green-500 focus-visible:border-green-500 focus-visible:ring-green-500/20",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

function Input({
	className,
	variant,
	type,
	leftIcon,
	...props
}: React.ComponentProps<"input"> &
	VariantProps<typeof inputVariants> & { leftIcon?: React.ReactNode }) {
	if (leftIcon) {
		return (
			<div className="relative">
				<span className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground">
					{leftIcon}
				</span>
				<input
					type={type}
					data-slot="input"
					className={cn(
						inputVariants({ variant }),
						"focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
						"aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
						className,
					)}
					{...props}
				/>
			</div>
		);
	}

	return (
		<input
			type={type}
			data-slot="input"
			className={cn(
				inputVariants({ variant }),
				"focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
				"aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
				className,
			)}
			{...props}
		/>
	);
}

export { Input, inputVariants };
